import React, { useState, useEffect, useContext } from 'react';
import { StateContext } from '../../../../StateProvider';
import { useNavigate } from 'react-router-dom';
import './Wallet.css';

import CardDisplay from '../../../../Utilities/components/CardDisplay/CardDisplay';

import tokenIcon from '../../../../../assets/Utilities/tokenIcon.png';
import addCardIcon from '../../../../../assets/Dashboard/Profile/components/Wallet/addCardIcon.png';

import { XButton, PaymentMethodViewButton, PaymentHistoryViewButton } from '../../../../Utilities/components/Buttons';
import Footer from '../../../../Footer';

const Wallet = () => {
  const navigate = useNavigate();
  const state = useContext(StateContext);

  var user = null;
  if (state && state.user) {
    user = state.user;
  }

  var paymentMethods = [];
  if (state && state.paymentMethods) {
    paymentMethods = state.paymentMethods;
  }

  const [tokenAmount, setTokenAmount] = useState(0);

  // Correct default card ID reference
  var defaultPaymentMethodId = null;
  if (user && user.defaultPaymentMethodId) {
    defaultPaymentMethodId = String(user.defaultPaymentMethodId);
  }

  useEffect(function () {
    if (user && user.wallet && user.wallet.balance) {
      var temp = user.wallet.balance;
      var numeric = parseFloat(temp);
      setTokenAmount(numeric);
    }
  }, [user]);

  function handleAddCard() {
    navigate('/profile/wallet/payment-methods/add-payment');
    window.scroll(0, 0);
  }

  return (
    <div>
      <div className="wallet-backdrop">
        <XButton />

        {/* BALANCE CARD */}
        <div className="wallet-container">
          <div
            className="wallet-card-container-one"
            onClick={function () {
              navigate('/profile/wallet/payment-history');
            }}
          >
            <h3 className="wallet-card-header">Pawsible Cash & Added Funds</h3>
            <p className="wallet-card-paragraph">Spend on eligible future services (terms apply)</p>

            <div className="wallet-card-token-container">
              <img src={tokenIcon} className="wallet-card-token-image" />
              <p className="wallet-card-token-amount">
                ${tokenAmount.toFixed(2)}
              </p>
            </div>

            <hr className="wallet-breakline" />

            <PaymentHistoryViewButton />
          </div>
        </div>

        {/* REFER */}
        <div className="wallet-container">
          <div
            className="wallet-card-container-two"
            onClick={function () {
              navigate('/store/deals/invite');
            }}
          >
            <h3 className="wallet-refer-header">Refer & earn!</h3>
            <p className="wallet-refer-paragraph">Invite friends to Pawsible, earn rewards up to $425.</p>
            <p className="wallet-refer-learn-paragraph">Learn more</p>
          </div>
        </div>
      </div>

      {/* GIFT CARDS */}
      <div
        className="wallet-container-two"
        onClick={function () {
          navigate('/store/deals/gift-card');
        }}
      >
        <h3 className="wallet-gift-card-header">Gift Cards</h3>
        <p className="wallet-gift-card-paragraph">The most un-fur-gettable gift card.</p>
        <button className="wallet-gift-card-button">Send gift card</button>
        <p className="wallet-gift-card-redeem">Redeem gift card</p>
      </div>

      <hr className="wallet-breakline2" />

      {/* PAYMENT METHODS */}
      <div className="wallet-container-three">
        <div className="wallet-view-button-container">
          <PaymentMethodViewButton />
        </div>

        <h3 className="wallet-payment-header">Payments</h3>
        <p className="wallet-payment-paragraph">Your payment methods.</p>

        {paymentMethods.length > 0 ? (
          <div>
            {(
              function () {
                var output = [];
                var i = 0;

                while (i < paymentMethods.length) {
                  var method = paymentMethods[i];
                  var isDefault = false;

                  // Correct default card check
                  if (
                    method &&
                    method.stripePaymentMethodId &&
                    defaultPaymentMethodId &&
                    String(method.stripePaymentMethodId) === defaultPaymentMethodId
                  ) {
                    isDefault = true;
                  }

                  output.push(
                    <div
                      key={method.id}
                      onClick={(function (stripeId) {
                        return function () {
                          navigate('/profile/wallet/payment-methods/edit-payment/' + stripeId);
                        };
                      })(method.stripePaymentMethodId)}
                    >
                      <CardDisplay method={method} isDefault={isDefault} />
                    </div>
                  );

                  i = i + 1;
                }

                return output;
              }
            )()}
          </div>
        ) : (
          <p>No payment methods added yet.</p>
        )}

        <hr className="wallet-payment-breakline" />

        {/* ADD CARD */}
        <div className="wallet-card-display" onClick={handleAddCard}>
          <img src={addCardIcon} className="wallet-card-logo" />
          <div className="wallet-card-info">
            <div className="wallet-card-number">Add Card</div>
          </div>
        </div>
      </div>

      <hr className="wallet-breakline2" />

      <Footer />
    </div>
  );
};

export default Wallet;
